import React, { useState } from 'react';
import { api } from '../api';

const CATEGORIES = [
  { value: 'harassment', label: 'Harassment or bullying' },
  { value: 'hate_speech', label: 'Hate speech or discrimination' },
  { value: 'sexual_content', label: 'Sexual or suggestive content' },
  { value: 'dress_code', label: 'Dress code violation' },
  { value: 'violence', label: 'Violence or self-harm' },
  { value: 'spam', label: 'Spam or scam' },
  { value: 'impersonation', label: 'Impersonation' },
  { value: 'doxxing', label: 'Sharing personal info (doxxing)' },
  { value: 'illegal', label: 'Illegal activity' },
  { value: 'copyright', label: 'Copyright violation' },
  { value: 'underage', label: 'Underage user' },
  { value: 'other', label: 'Other' },
];

export default function ReportDialog({ username, streamId, onClose }) {
  const [category, setCategory] = useState('');
  const [details, setDetails] = useState('');
  const [status, setStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!category) { setStatus('Please select a reason'); return; }
    setSubmitting(true);
    setStatus('');
    try {
      const res = await api.report({ username, stream_id: streamId, category, details });
      setStatus(res.message);
      setTimeout(() => onClose(), 2000);
    } catch (e) {
      setStatus(`Error: ${e.message}`);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: '#18181b', borderRadius: '2px', padding: '28px', width: '100%', maxWidth: '440px', boxShadow: '4px 4px 0 rgba(0,0,0,0.5)', border: '1px solid #2a2a2e' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ fontFamily: 'var(--font-body)', fontSize: '1.1rem', fontWeight: 800 }}>
            Report @{username}
          </h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#adadb8', cursor: 'pointer', fontSize: '1.2rem' }}>✕</button>
        </div>

        <div className="form-group">
          <label>Reason</label>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {CATEGORIES.map(c => (
              <button
                key={c.value}
                onClick={() => setCategory(c.value)}
                style={{
                  padding: '10px 12px', borderRadius: '2px', border: '1px solid',
                  borderColor: category === c.value ? 'var(--accent)' : '#2a2a2e',
                  background: category === c.value ? '#D6E9AA11' : '#0e0e10',
                  color: category === c.value ? '#efeff1' : '#adadb8',
                  cursor: 'pointer', textAlign: 'left', fontSize: '0.85rem', fontWeight: 600,
                  transition: 'all 0.1s',
                }}
              >
                {c.label}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group" style={{ marginTop: '12px' }}>
          <label>Additional details (optional)</label>
          <textarea
            className="input"
            placeholder="Describe what happened..."
            value={details}
            onChange={e => setDetails(e.target.value)}
            maxLength={1000}
            rows={3}
            style={{ resize: 'vertical', minHeight: '60px', fontFamily: 'inherit', marginBottom: 0 }}
          />
        </div>

        {status && (
          <p style={{ fontSize: '0.85rem', marginTop: '12px', color: status.startsWith('Error') ? '#eb0400' : '#00c400' }}>
            {status}
          </p>
        )}

        <div style={{ display: 'flex', gap: '8px', marginTop: '16px' }}>
          <button className="btn btn-danger" onClick={handleSubmit} disabled={submitting || !category} style={{ flex: 1 }}>
            {submitting ? 'Submitting...' : 'Submit Report'}
          </button>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
